var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 6.75C13 7.30228 12.5523 7.75 12 7.75C11.4477 7.75 11 7.30228 11 6.75C11 6.19772 11.4477 5.75 12 5.75C12.5523 5.75 13 6.19772 13 6.75Z",
    fill: "#2F3C46",
    stroke: "#2F3C46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 1.5C13 2.05228 12.5523 2.5 12 2.5C11.4477 2.5 11 2.05228 11 1.5C11 0.947715 11.4477 0.5 12 0.5C12.5523 0.5 13 0.947715 13 1.5Z",
    fill: "#2F3C46",
    stroke: "#2F3C46"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12Z",
    fill: "#2F3C46",
    stroke: "#2F3C46"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 17.25C13 17.8023 12.5523 18.25 12 18.25C11.4477 18.25 11 17.8023 11 17.25C11 16.6977 11.4477 16.25 12 16.25C12.5523 16.25 13 16.6977 13 17.25Z",
    fill: "#2F3C46",
    stroke: "#2F3C46"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C12.8284 24 13.5 23.3284 13.5 22.5C13.5 21.6716 12.8284 21 12 21C11.1716 21 10.5 21.6716 10.5 22.5C10.5 23.3284 11.1716 24 12 24Z",
    fill: "#2F3C46"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.25V18.75C2 19.5457 2.31607 20.3087 2.87868 20.8713C3.44129 21.4339 4.20435 21.75 5 21.75H8C8.55228 21.75 9 21.3023 9 20.75V20.7211C9 20.1689 8.55228 19.7211 8 19.7211H5C4.44772 19.7211 4 19.2734 4 18.7211V5.33609C4 4.78381 4.44772 4.33609 5 4.33609H8C8.55228 4.33609 9 3.88838 9 3.33609V3.25C9 2.69772 8.55228 2.25 8 2.25H5C4.20435 2.25 3.44129 2.56607 2.87868 3.12868C2.31607 3.69129 2 4.45435 2 5.25Z",
    fill: "#2F3C46"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19 2.25H16C15.4477 2.25 15 2.69772 15 3.25V3.2943C15 3.84659 15.4477 4.2943 16 4.2943H19C19.5523 4.2943 20 4.74202 20 5.2943V18.7513C20 19.3036 19.5523 19.7513 19 19.7513H15.9993C15.4474 19.7513 15 20.1987 15 20.7507C15 21.3026 15.4474 21.75 15.9993 21.75H19C19.7957 21.75 20.5587 21.4339 21.1213 20.8713C21.6839 20.3087 22 19.5457 22 18.75V5.25C22 4.45435 21.6839 3.69129 21.1213 3.12868C20.5587 2.56607 19.7957 2.25 19 2.25Z",
    fill: "#2F3C46"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompare);
export default __webpack_public_path__ + "static/media/compare.1226aa2d.svg";
export { ForwardRef as ReactComponent };